var map = {
	"./community-category/index.sync.tsx": 859,
	"./content-curation/HomepageContentCurationContainer.sync.tsx": 860,
	"./header-navigation/index.sync.tsx": 889,
	"./ideation-destination/filters/ProductAreaFilter.sync.tsx": 909,
	"./knowledge-base/index.sync.tsx": 912,
	"./product-updates-destination/ProductUpdatesOverview.sync.tsx": 922,
	"./widget-featured-topics/index.sync.tsx": 379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1369;